import { useTranslation } from "@refinedev/core";
import { useBack, useLink, useTranslate } from "@refinedev/core";


export function PageUnauthorized() {
    const goBack = useBack();
    const { translate } = useTranslation()

    const Link = useLink()
    return <div className="h-full flex flex-col items-center justify-center relative bg-secondary overflow-hidden">
        <img src="/img/hachi-corner-crazy-animated.svg" className="absolute bottom-0 right-0 w-40 md:w-64" alt="hachi corner" />
        <div className="relative text-base-100  text-center">
            <div className="hover:scale-105 transition-all top-0 right-0 z-10 translate-x-1/2 translate-y-1/2 absolute w-16 h-16 rounded-full bg-primary"></div>
            <div className="hover:scale-105 transition-all top-0 left-0 z-10 -translate-y-[110%] md:-translate-x-[120%] md:-translate-y-1/2 absolute w-40 h-40 rounded-full bg-primary"></div>
            <h1 className="text-5xl font-bold mb-4">Hachimind</h1>
            <h2 className="text-2xl">{translate('common.unauthorized')}</h2>
            <p className="lowercase">
                <span className="text-center block text-7xl font-black my-4">401</span>
                {translate("common.nothing-to-see")} {" "}
                <Link to="#" className="link" onClick={goBack}>{translate('common.go-back')}</Link> {" "}
                {translate('common.or')} {" "}
                <Link to="/" className="link" onClick={goBack}>{translate('common.go-home')}</Link>
            </p>
        </div>
    </div>
}
